const deviceFilter = {
  i18nTitle: "dropdown.titles.device",
  name: "device",
  values: [
    {
      i18nKey: "dropdown.device.mobile",
      name: "mobile",
      value: 1,
    },
    {
      i18nKey: "dropdown.device.desktop",
      name: "desktop",
      value: 2,
    },
  ],
};

const productsFilter = {
  i18nTitle: "dropdown.titles.products",
  name: "products",
  values: [
    {
      i18nKey: "dropdown.products.fitIllustrator",
      name: "fitIllustrator",
      value: 1,
    },
    {
      i18nKey: "dropdown.products.inpage",
      name: "inpage",
      value: 2,
    },
    {
      i18nKey: "dropdown.products.smartTable",
      name: "smartTable",
      value: 3,
    },
  ],
};

const itemCategoriesFilter = {
  i18nTitle: "dropdown.titles.itemCategories",
  name: "itemCategories",
  values: [
    {
      i18nKey: "dropdown.itemCategories.all",
      name: "all",
      value: 0,
    },
    {
      i18nKey: "dropdown.itemCategories.dress",
      name: "dress",
      value: 1,
    },
    {
      i18nKey: "dropdown.itemCategories.shirt",
      name: "shirt",
      value: 2,
    },
    {
      i18nKey: "dropdown.itemCategories.sweater",
      name: "sweater",
      value: 3,
    },
    {
      i18nKey: "dropdown.itemCategories.tShirt",
      name: "tShirt",
      value: 4,
    },
    {
      i18nKey: "dropdown.itemCategories.pants",
      name: "pants",
      value: 5,
    },
    {
      i18nKey: "dropdown.itemCategories.panties",
      name: "panties",
      value: 6,
    },
    {
      i18nKey: "dropdown.itemCategories.skirt",
      name: "skirt",
      value: 7,
    },
    {
      i18nKey: "dropdown.itemCategories.jacket",
      name: "jacket",
      value: 8,
    },
    {
      i18nKey: "dropdown.itemCategories.straplessDress",
      name: "straplessDress",
      value: 11,
    },
    {
      i18nKey: "dropdown.itemCategories.tops",
      name: "tops",
      value: 12,
    },
    {
      i18nKey: "dropdown.itemCategories.shorts",
      name: "shorts",
      value: 13,
    },
    {
      i18nKey: "dropdown.itemCategories.coat",
      name: "coat",
      value: 14,
    },
    {
      i18nKey: "dropdown.itemCategories.tunic",
      name: "tunic",
      value: 15,
    },
    {
      i18nKey: "dropdown.itemCategories.dressWithSleeves",
      name: "dressWithSleeves",
      value: 16,
    },
    {
      i18nKey: "dropdown.itemCategories.shoes",
      name: "shoes",
      value: 17,
    },
    {
      i18nKey: "dropdown.itemCategories.bag",
      name: "bag",
      value: 18,
    },
    {
      i18nKey: "dropdown.itemCategories.clutch",
      name: "clutch",
      value: 19,
    },
    {
      i18nKey: "dropdown.itemCategories.tunicWithSleeves",
      name: "tunicWithSleeves",
      value: 20,
    },
    {
      i18nKey: "dropdown.itemCategories.wellingtonGlasses",
      name: "wellingtonGlasses",
      value: 21,
    },
    {
      i18nKey: "dropdown.itemCategories.squareGlasses",
      name: "squareGlasses",
      value: 22,
    },
    {
      i18nKey: "dropdown.itemCategories.ovalGlasses",
      name: "ovalGlasses",
      value: 23,
    },
    {
      i18nKey: "dropdown.itemCategories.bostonGlasses",
      name: "bostonGlasses",
      value: 24,
    },
    {
      i18nKey: "dropdown.itemCategories.wallet",
      name: "wallet",
      value: 25,
    },
  ],
};

const regionList = (currentStore) => {
  const values = [];
  currentStore["region_list"].forEach((region) => {
    values.push({ i18nKey: `dropdown.countries.${region}`, name: region, value: region });
  });
  values.push({ i18nKey: "dropdown.countries.others", name: "others", value: "others" });
  return {
    i18nTitle: "dropdown.titles.countries",
    name: "countries",
    values,
  };
};

const allFilters = (currentStore) => [deviceFilter, productsFilter, itemCategoriesFilter, regionList(currentStore)];

const coverageFilters = (currentStore) => [deviceFilter, productsFilter, regionList(currentStore)];

export default (page, currentStore) => (page === "coverage" ? coverageFilters(currentStore) : allFilters(currentStore));
